export const testimonies = [
  {
    src: 'francois_mazon.png',
    alt: 'francois_mazon',
    text:
      'Doctrine n’est pas un simple outil de recherche, c’est un outil stratégique.',
    name: 'François Mazon',
    situation: 'Avocat pénaliste au barreau de Marseille',
  },
  {
    src: 'francois_saint_pierre.png',
    alt: 'francois_saint_pierre',
    text:
      'Doctrine est un accélérateur de travail qui rend l’avocat plus performant. C’est un outil indispensable.',
    name: 'François Saint-Pierre',
    situation: 'Avocat pénaliste au barreau de Lyon',
  },
  {
    src: 'pierre_bregou.png',
    alt: 'pierre_bregou',
    text:
      'Doctrine est une meilleure source d’informations que le client lui même. C’est un must-have, pas un simple accessoire.',
    name: 'Pierre Brégou',
    situation: 'Avocat en droit social au barreau de Paris',
  },
];
